module.exports = __webpack_public_path__ + "static/media/aboutUs-LearningTeam.52aa2370.png";